import api from "../lib/utils/apiConfig";
import { PERMISSION, ROLE, USER } from "./constant";

export const listPermissions = async () => (await api.get(PERMISSION.LIST)).data;
export const listRoles = async () => (await api.get(ROLE.LIST)).data;
export const getRole = async (id) => (await api.get(ROLE.GET(id))).data;
export const createRole = async (data) => (await api.post(ROLE.CREATE, data)).data;
export const updateRole = async (id, data) => (await api.put(ROLE.UPDATE(id), data)).data;
export const replaceRolePermissions = async (id, permissionIds) =>
  (await api.put(ROLE.PERMISSIONS(id), { permission_ids: permissionIds })).data;
export const deleteRole = async (id) => (await api.delete(ROLE.DELETE(id))).data;

export const listAdminUsers = async (search = "") =>
  (await api.get(USER.LIST, { params: { search } })).data;
export const createAdminUser = async (data) => (await api.post(USER.CREATE, data)).data;
export const updateAdminUser = async (id, data) => (await api.put(USER.UPDATE(id), data)).data;
export const replaceAdminUserRoles = async (id, roleIds) =>
  (await api.put(USER.ROLES(id), { role_ids: roleIds })).data;
export const changeAdminUserStatus = async (id, status) =>
  (await api.patch(USER.STATUS(id), { status })).data;
